<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" lg="4">
        <v-card class="elevation-12" min-width="500" v-if="requestStage !== 'ended'">
          <v-toolbar color="primary" dark flat dense>
            <v-toolbar-title>Восстановление пароля</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="requestCode"
              label="Код запроса"
              type="text"
              required
              :disabled="Boolean(this.reqid)"
            ></v-text-field>
            <v-text-field
              v-model="newPassword"
              label="Новый пароль"
              type="password"
              :rules="[rules.required, rules.isPass]"
              @update:error="setError"
              required
            ></v-text-field>
            <v-text-field
              v-model="newPassword2"
              label="Повторите пароль"
              type="password"
              :rules="[rules.required, rules.isPass, rules.passEQ]"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined rounded color="primary" @click="goLogin()" min-width="200">Отмена</v-btn>
            <v-spacer></v-spacer>
            <v-btn  rounded color="primary" class="white--text" @click="doRequest" min-width="200" :disabled="!canRequest">Запрос</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="elevation-12" v-if="requestStage == 'ended'">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Запрос обработан</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <p class="display-1 text--primary">
              Ваш пароль изменён.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined rounded color="primary" @click="goLogin" min-width="200">ОК</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AUTH_PC_REQUEST } from '@/store/actions/auth'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'sysPasswordRecovery',
  props: ['reqid'],
  data () {
    return {
      newPassword: '',
      newPassword2: '',
      requestStage: 'init',
      requestResult: '',
      reqCode: '',
      inputError: true,
      rules: {
        required: value => !!value || 'Поле обязательно для заполнения',
        isPass: value => {
          const pattern = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
          return pattern.test(value) || 'Пароль не соответствует требованиям. Мин. 8 символов в РАЗНЫХ регистрах, как минимум, 1 цифра, как минимум 1 спец. символ'
        },
        passEQ: value => this.newPassword === this.newPassword2 || 'Пароли не совпадают'
      }
    }
  },
  computed: {
    canRequest: {
      get: function () {
        return Boolean(this.requestCode) && this.passwordIsSet
      }
    },
    passwordIsSet: {
      get: function () {
        if (this.newPassword === this.newPassword2) {
          return !this.inputError
        }
        return false
      }
    },
    requestCode: {
      get: function () {
        return this.reqid ? this.reqid : this.reqCode
      },
      set: function (val) {
        this.reqCode = val
      }
    }
  },
  methods: {
    setError (val) {
      this.inputError = val
    },
    goLogin () {
      this.$router.push('/login')
    },
    doRequest: function (e) {
      if (e) { e.preventDefault() }
      const payload = {
        reqCode: this.requestCode,
        newPassword: this.newPassword
      }
      this.$store.dispatch(AUTH_PC_REQUEST, payload)
        .then((data) => {
          if (data.error === 'ok') {
            this.requestStage = 'ended'
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: data.error_text })
          }
        })
        .catch((err) => {
          console.log('Request Rejected')
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    }
  }
}
</script>
